import { Outlet } from 'react-router-dom';
import type { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';

interface LayoutProps {
  children?: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="skf-page">
      <Header />
      <main>{children ?? <Outlet />}</main>
      <Footer />
    </div>
  );
}
